exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".smb-advert-invoicing .header-text-component{color:#40710a}.smb-advert-invoicing .accordion-section.expanded{background-color:hsla(80,59%,75%,.11)}.smb-advert-payments .header-text-component{color:#1e88e5}.smb-advert-payments .accordion-section.expanded{background-color:rgba(178,221,246,.11)}", ""]);

// exports
